import './InspectorImageInfo.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { doNothingAsync } from '../../../../__legacy__/helpers/function.helpers';
import { IModelImageDto } from '../../../../__legacy__/modules/annotation/annotations.interface';
import { ImageSetBadge } from '../../../../__legacy__/modules/annotation/components/ImageSetBadge';

interface IInspectorImageInfoProps {
  image: IModelImageDto | null;
}

export const InspectorImageInfo = ({ image }: IInspectorImageInfoProps): ReactElement => {
  const { t } = useTranslator();
  const hasData = image && image.imageSetType;
  if (!hasData) {
    return <></>;
  }

  return (
    <div className='predictions-view annotation-tools-readonly-overlay inspector-image-info'>
      <div className='header'>
        <FontAwesomeIcon icon='info-circle' /> {t('additional_info')}
      </div>
      <div className='predictions-view-inner'>
        {image.imageSetType && (
          <div className='inspector-image-info-row'>
            <span>{t('set_as')}: </span>
            <ImageSetBadge
              set={image.imageSetType}
              onChange={doNothingAsync}
              disabled={true}
            />
          </div>
        )}
      </div>
    </div>
  );
};
